import { Model } from '@/models/Model';
import { Country } from '@/models/Country';

export class AddressCheck extends Model
{
  protected $name: string = 'AddressCheck';
  protected $endpoint: string = '/address/check';
  protected $fillable: string[] = [
    'zip_code',
    'house_number',
    'addition',
  ];

  public zip_code?: string;
  public house_number?: string;
  public addition?: string;

  public city?: string;
  public postalCode?: string;
  public streetName?: string;
  public houseNumber?: string;
  public houseNumberAddition?: string;
  public formattedAddress?: string[];

  public postCheck(attributes: any): Promise<any> {
    const url = this.$endpoint;

    attributes = this.getPayload(attributes);

    return this.request('post', url, attributes);
  }
}

export type AddressCheckPayload = {
  zip_code?: string;
  house_number?: string;
  addition?: string;
}
